export function getOverflowHiddenAncestor(element: Element) {
  let ancestor = element;

  // Find the closest ancestor with overflow: hidden
  while (ancestor && ancestor !== document.documentElement) {
    const style = getComputedStyle(ancestor);
    if (style.overflow === 'hidden' || style.overflowY === 'hidden') {
      break;
    }
    ancestor = ancestor.parentElement;
  }

  // If no ancestor with overflow: hidden is found, use the root element
  if (!ancestor) {
    return document.documentElement;
  }
  return ancestor;
}
